// extracted by mini-css-extract-plugin
export default {"NewContentTypeDialog":"NewContentTypeDialog_NewContentTypeDialog__8gkIZ"};